import React from 'react';
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export default function EnvVarTable({ envVars = [], title = 'Environment variables' }) {
  if (!envVars.length) return null;

  return (
    <BoxSection title={title}>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Variable</TableCell>
              <TableCell>Required</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {envVars.map((row) => (
              <TableRow key={row.key}>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 13 }}>{row.key}</TableCell>
                <TableCell>
                  <Chip
                    label={row.required ? 'Yes' : 'No'}
                    size="small"
                    color={row.required ? 'error' : 'default'}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </BoxSection>
  );
}

export function EndpointTable({ endpoints = [], title = 'API endpoints' }) {
  if (!endpoints.length) return null;

  return (
    <BoxSection title={title}>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Method</TableCell>
              <TableCell>Path</TableCell>
              <TableCell>Auth</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {endpoints.map((row) => (
              <TableRow key={`${row.method}-${row.path}`}>
                <TableCell>
                  <Chip label={row.method} size="small" variant="outlined" />
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{row.path}</TableCell>
                <TableCell>{row.auth || '—'}</TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </BoxSection>
  );
}

export function RelatedFilesList({ files = [] }) {
  if (!files.length) return null;

  return (
    <BoxSection title="Related files">
      {files.map((file) => (
        <Chip
          key={file.path}
          label={file.role ? `${file.path} — ${file.role}` : file.path}
          size="small"
          sx={{ mr: 1, mb: 1, maxWidth: '100%', height: 'auto', '& .MuiChip-label': { whiteSpace: 'normal' } }}
        />
      ))}
    </BoxSection>
  );
}

function BoxSection({ title, children }) {
  return (
    <>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 2, mb: 1 }}>
        {title}
      </Typography>
      {children}
    </>
  );
}
